import PropTypes from "prop-types"
import { indexOf } from "lodash"
import { LOADING, ERROR } from "helpers/data-statuses"
import Loading from "components/loading"
import Error from "components/error"

function LoadingWrapper({ status, children, loadingComponent, errorComponent }) {
  if (indexOf(status, LOADING) > -1) {
    return loadingComponent || <Loading />
  } else if (indexOf(status, ERROR) > -1) {
    return errorComponent || <Error />
  } else {
    return children
  }
}

LoadingWrapper.propTypes = {
  status: PropTypes.array.isRequired,
  children: PropTypes.node.isRequired,
  loadingComponent: PropTypes.object,
  errorComponent: PropTypes.object,
}

export default LoadingWrapper
